module.exports = __webpack_public_path__ + "static/loading_reimu-1.0.0.gif";